import './awaitingPopup.scss'

import React from 'react'

import Popup from '../../../../popup/Popup'

import classNames from 'classnames';
import { ReactComponent as UnFoundIcon } from "./images/opponent_not_found.svg"

export default class AwaitingPopup extends React.Component {
  render() {
    return (
      <Popup
        className="awaiting-popup"
        title={this.props.notFound ? 'Opponent not found' : 'Awaiting...'}
        closable={false}
        buttons={
          this.props.notFound
            ? [{ text: 'Search again', handler: this.props.onRetry }]
            : null
        }
        onClose={this.props.onClose}
      >
        <div className="awaiting-content">
          {this.props.notFound ?
            <div className="img-inline">
              <UnFoundIcon />
            </div>
            :
            <div className="img searching" />
          }
          <div>
            {this.props.notFound
              ? 'Please try again'
              : 'Searching for an opponent...'}
          </div>
        </div>
      </Popup>
    )
  }
}
